import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Droplets, Loader2, ArrowLeft, Lock } from 'lucide-react';
import { toast } from 'sonner';
import Button from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('admin@aguasvivas.com');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Bem-vindo de volta!');
      navigate('/admin', { replace: true });
    } catch (err) {
      toast.error(err.message || 'Falha no login.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen px-5 py-6">
      <div className="app-container !px-0">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-1.5 text-sm font-semibold text-ink-soft hover:text-primary"
          data-testid="login-back"
        >
          <ArrowLeft size={16} /> Voltar
        </button>

        <div className="mx-auto mt-10 w-full max-w-md">
          <div className="flex flex-col items-start">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-white shadow-lift">
              <Droplets size={28} />
            </span>
            <h1 className="mt-5 font-heading text-3xl font-extrabold text-ink">Área Administrativa</h1>
            <p className="mt-1 text-sm text-ink-soft">
              Gerencie redes, células, eventos e galeria.
            </p>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <Input
              label="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
            />
            <Input
              label="Senha"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
            />
            <Button type="submit" size="lg" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 size={18} className="animate-spin" /> : <><Lock size={17} /> Entrar</>}
            </Button>
          </form>

          <p className="mt-6 rounded-xl bg-primary-light/60 px-4 py-3 text-xs text-primary-dark" data-testid="login-hint">
            <strong>Demo:</strong> admin@aguasvivas.com · admin123
          </p>
        </div>
      </div>
    </div>
  );

}
